import React from 'react';
import { Fan } from 'lucide-react';

export interface FanSpeedStyle01Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
}

// Speed display translations
const SPEED_LABELS: Record<string, string> = {
  '1': '低速',
  '2': '中速',
  '3': '高速',
  '4': '速度 4',
  'low': '低速',
  'medium': '中速',
  'high': '高速',
  'auto': '自動'
};

/**
 * FanSpeed Style 01 - Button Group
 * Command: SetFanSpeed
 * Horizontal button group for fan speed selection
 */
export const Style01_Buttons: React.FC<FanSpeedStyle01Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '風速'
}) => {
  const getSpeedLabel = (speed: string): string => {
    return SPEED_LABELS[speed] || speed;
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Fan className="w-4 h-4 text-cyan-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((speed) => {
          const isSelected = value === speed;
          return (
            <button
              key={speed}
              onClick={() => onChange(speed)}
              disabled={disabled || loading}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                isSelected
                  ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/30'
                  : 'bg-slate-700/50 text-slate-300 hover:bg-slate-600'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : getSpeedLabel(speed)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style01_Buttons;
